import { Badge } from '@monksflow/monks-ui';
import type { Category } from '@inference.engine/guidelines';
import { formatCategoryLabel } from '@/features/guidelines/constants';

export interface CategoryBadgeCellProps {
  category: Category;
}

/**
 * Tessra `Badge` has no hue axis, so every category renders the same neutral
 * variant. The per-category colour the legacy `Chip` carried is a reported,
 * not absorbed, regression — see the design's note to design.
 */
export function CategoryBadgeCell({ category }: CategoryBadgeCellProps) {
  return (
    <Badge variant="secondary" roundness="full">
      {formatCategoryLabel(category)}
    </Badge>
  );
}

CategoryBadgeCell.displayName = 'CategoryBadgeCell';
